import { CLEAR_LIST_PROCESSING } from 'root/src/client/logic/api/actionIds'

export default currentRouteObj => ({
	type: CLEAR_LIST_PROCESSING,
	payload: { currentRouteObj },
})
